import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getBfixRateTypes, saveBfixRateTypesBatch } from '../../api/bfixRateTypes';
import type { BFIXRateType } from '../../types/BFIXRateType';
import { t } from '../../i18n/t';

const bfixRateTypesColumnDefs: ColDef<BFIXRateType>[] = [
  {
    field: 'bfixRateTypeId',
    headerName: t('bfixRateTypes.columns.bfixRateTypeId'),
    width: 120,
    // Natural PK: editable on Add only.
    editable: (params: EditableCallbackParams<BFIXRateType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'bfixRateTypeName',
    headerName: t('bfixRateTypes.columns.bfixRateTypeName'),
    flex: 1,
    editable: true,
  },
];

const newBfixRateTypeDefaults = (): Partial<BFIXRateType> => ({
  bfixRateTypeId: 0,
  bfixRateTypeName: '',
});

export function BFIXRateTypesPage() {
  return (
    <LopCrudPage<BFIXRateType>
      resourceCode="bfixRateTypes"
      titleKey="bfixRateTypes.pageTitle"
      idField="bfixRateTypeId"
      getRows={getBfixRateTypes}
      saveBatch={(added, modified, deletedIds) =>
        saveBfixRateTypesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={bfixRateTypesColumnDefs}
      newRowDefaults={newBfixRateTypeDefaults}
    />
  );
}
